module.exports = __webpack_public_path__ + "img/mp.ac215736.png";